import {
  getActivityLogFileUrl,
  getDataForMediaUrl
} from "src/modules/activity-log/ajax/cloud";

class BlobDataCache {
  urls = [];

  async set(event, monitoringId, fileExtension = "jpg") {
    try {
      const fileName = event.fileName.value;

      const { signedUrl } = await getActivityLogFileUrl({
        fileName: fileName + ".thumbnail",
        fileExtension
      });
      const { blob, dataUrl } = await getDataForMediaUrl(signedUrl);
      const base64 = await this.blobToBase64(blob);

      window.sessionStorage.setItem(
        `${monitoringId}_${event.id}`,
        JSON.stringify({ blob: base64 })
      );
      this.urls.push(dataUrl);
      return dataUrl;
    } catch (err) {
      this.clearStorage();
    }
  }

  async get(event, monitoringId, fileExtension) {
    try {
      let base64string = window.sessionStorage.getItem(
        `${monitoringId}_${event.id}`
      );
      if (!base64string) {
        const dataUrl = await this.set(event, monitoringId, fileExtension);
        return dataUrl;
      }
      const parsed = JSON.parse(base64string);
      const blob = await fetch(parsed.blob).then((res) => res.blob());
      const dataUrl = URL.createObjectURL(blob);
      return dataUrl;
    } catch (err) {
      this.clearStorage();
    }
  }

  blobToBase64 = (blob) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  };

  revokeUrls() {
    for (let url of this.urls) {
      URL.revokeObjectURL(url);
    }
    this.urls = [];
  }

  clearStorage() {
    window.sessionStorage.clear();
  }
}

const blobDataCache = new BlobDataCache();
export { blobDataCache };
